var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container mt-5" }, [
    _c("div", { staticClass: "row mt-5" }, [
      _c("div", { staticClass: "col-lg-2 col-md-2 col-sm-12" }, [
        _c(
          "div",
          { staticClass: "p-2 alert alert-secondary" },
          [
            _c("h3", [_vm._v("Back Log")]),
            _c(
              "draggable",
              {
                staticClass: "list-group kanban-column",
                attrs: { list: _vm.arrBackLog, group: "tasks" },
                on: {
                  change: function ($event) {
                    return _vm.statusUpdated(0, _vm.arrBackLog)
                  },
                },
              },
              _vm._l(_vm.arrBackLog, function (element) {
                return _c(
                  "div",
                  { key: element.id, staticClass: "list-group-item" },
                  [
                    _vm._v(" " + _vm._s(element.name) + " "),
                    _c(
                      "div",
                      [
                        _c("b-form-textarea", {
                          attrs: {
                            id: "textarea-default",
                            placeholder: "Comment",
                            rows: "3",
                          },
                          on: {
                            blur: function ($event) {
                              return _vm.updateComment(element)
                            },
                          },
                          model: {
                            value: element.comment,
                            callback: function ($$v) {
                              _vm.$set(element, "comment", $$v)
                            },
                            expression: "element.comment",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                )
              }),
              0
            ),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "col-lg-2 col-md-2 col-sm-12" }, [
        _c(
          "div",
          { staticClass: "p-2 alert alert-primary" },
          [
            _c("h3", [_vm._v("Started")]),
            _c(
              "draggable",
              {
                staticClass: "list-group kanban-column",
                attrs: { list: _vm.arrInProgress, group: "tasks" },
                on: {
                  change: function ($event) {
                    return _vm.statusUpdated(1, _vm.arrInProgress)
                  },
                },
              },
              _vm._l(_vm.arrInProgress, function (element) {
                return _c(
                  "div",
                  { key: element.name, staticClass: "list-group-item" },
                  [
                    _vm._v(" " + _vm._s(element.name) + " "),
                    _c(
                      "div",
                      [
                        _c("b-form-textarea", {
                          attrs: {
                            id: "textarea-default",
                            placeholder: "Comment",
                            rows: "3",
                          },
                          on: {
                            blur: function ($event) {
                              return _vm.updateComment(element)
                            },
                          },
                          model: {
                            value: element.comment,
                            callback: function ($$v) {
                              _vm.$set(element, "comment", $$v)
                            },
                            expression: "element.comment",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                )
              }),
              0
            ),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "col-lg-2 col-md-2 col-sm-12" }, [
        _c(
          "div",
          { staticClass: "p-2 alert alert-warning" },
          [
            _c("h3", [_vm._v("On Hold")]),
            _c(
              "draggable",
              {
                staticClass: "list-group kanban-column",
                attrs: { list: _vm.arrHold, group: "tasks" },
                on: {
                  change: function ($event) {
                    return _vm.statusUpdated(2, _vm.arrHold)
                  },
                },
              },
              _vm._l(_vm.arrHold, function (element) {
                return _c(
                  "div",
                  { key: element.name, staticClass: "list-group-item" },
                  [
                    _vm._v(" " + _vm._s(element.name) + " "),
                    _c(
                      "div",
                      [
                        _c("b-form-textarea", {
                          attrs: {
                            id: "textarea-default",
                            placeholder: "Comment",
                            rows: "3",
                          },
                          on: {
                            blur: function ($event) {
                              return _vm.updateComment(element)
                            },
                          },
                          model: {
                            value: element.comment,
                            callback: function ($$v) {
                              _vm.$set(element, "comment", $$v)
                            },
                            expression: "element.comment",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                )
              }),
              0
            ),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "col-lg-2 col-md-2 col-sm-12" }, [
        _c(
          "div",
          { staticClass: "p-2 alert alert-info" },
          [
            _c("h3", [_vm._v("WIP 1")]),
            _c(
              "draggable",
              {
                staticClass: "list-group kanban-column",
                attrs: { list: _vm.arrInWIP, group: "tasks" },
                on: {
                  change: function ($event) {
                    return _vm.statusUpdated(3, _vm.arrInWIP)
                  },
                },
              },
              _vm._l(_vm.arrInWIP, function (element) {
                return _c(
                  "div",
                  { key: element.name, staticClass: "list-group-item" },
                  [
                    _vm._v(" " + _vm._s(element.name) + " "),
                    _c(
                      "div",
                      [
                        _c("b-form-textarea", {
                          attrs: {
                            id: "textarea-default",
                            placeholder: "Comment",
                            rows: "3",
                          },
                          on: {
                            blur: function ($event) {
                              return _vm.updateComment(element)
                            },
                          },
                          model: {
                            value: element.comment,
                            callback: function ($$v) {
                              _vm.$set(element, "comment", $$v)
                            },
                            expression: "element.comment",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                )
              }),
              0
            ),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "col-lg-2 col-md-2 col-sm-12" }, [
        _c(
          "div",
          { staticClass: "p-2 alert alert-info" },
          [
            _c("h3", [_vm._v("WIP 2")]),
            _c(
              "draggable",
              {
                staticClass: "list-group kanban-column",
                attrs: { list: _vm.arrInWIP2, group: "tasks" },
                on: {
                  change: function ($event) {
                    return _vm.statusUpdated(4, _vm.arrInWIP2)
                  },
                },
              },
              _vm._l(_vm.arrInWIP2, function (element) {
                return _c(
                  "div",
                  { key: element.name, staticClass: "list-group-item" },
                  [
                    _vm._v(" " + _vm._s(element.name) + " "),
                    _c(
                      "div",
                      [
                        _c("b-form-textarea", {
                          attrs: {
                            id: "textarea-default",
                            placeholder: "Comment",
                            rows: "3",
                          },
                          on: {
                            blur: function ($event) {
                              return _vm.updateComment(element)
                            },
                          },
                          model: {
                            value: element.comment,
                            callback: function ($$v) {
                              _vm.$set(element, "comment", $$v)
                            },
                            expression: "element.comment",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                )
              }),
              0
            ),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "col-lg-2 col-md-2 col-sm-12" }, [
        _c(
          "div",
          { staticClass: "p-2 alert alert-success" },
          [
            _c("h3", [_vm._v("Completed")]),
            _c(
              "draggable",
              {
                staticClass: "list-group kanban-column",
                attrs: { list: _vm.arrDone, group: "tasks" },
                on: {
                  change: function ($event) {
                    return _vm.statusUpdated(5, _vm.arrDone)
                  },
                },
              },
              _vm._l(_vm.arrDone, function (element) {
                return _c(
                  "div",
                  { key: element.name, staticClass: "list-group-item" },
                  [
                    _vm._v(" " + _vm._s(element.name) + " "),
                    _c(
                      "div",
                      [
                        _c("b-form-textarea", {
                          attrs: {
                            id: "textarea-default",
                            placeholder: "Comment",
                            rows: "3",
                          },
                          on: {
                            blur: function ($event) {
                              return _vm.updateComment(element)
                            },
                          },
                          model: {
                            value: element.comment,
                            callback: function ($$v) {
                              _vm.$set(element, "comment", $$v)
                            },
                            expression: "element.comment",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                )
              }),
              0
            ),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }